import { z } from "zod/v4";

const functionURLSchema = z.object({
  query: z.string().optional(),
  explain: z.string().optional(),
  explainWrongAnswer: z.string().optional(),
  examQuestionConversation: z.string().optional()
});

const baseServiceSchema = z.object({
  protocol: z.string(),
  host: z.string()
});

const authenticationServiceSchema = baseServiceSchema.extend({
  userPoolClientId: z.string(),
  userPoolId: z.string(),
  userPoolEndpoint: z.string(),
  retryCount: z.number()
});

const chatbotServiceSchema = baseServiceSchema.extend({
  functionURL: functionURLSchema
});

const courseServiceSchema = baseServiceSchema.extend({
  baseCdnUrl: z.string()
});

const imageCdnSchema = baseServiceSchema.extend({
  cdnBaseUrl: z.string()
});

const imageServiceSchema = baseServiceSchema.extend({
  cdnBaseUrl: z.string()
});

export const servicesSchema = z.object({
  adminGatewayService: baseServiceSchema,
  authenticationService: authenticationServiceSchema,
  assignmentsService: baseServiceSchema,
  chatbotService: chatbotServiceSchema,
  courseService: courseServiceSchema,
  userService: baseServiceSchema,
  statsService: baseServiceSchema,
  memoryService: baseServiceSchema,
  imageCdn: imageCdnSchema,
  imageService: imageServiceSchema,
  imageTagsService: baseServiceSchema,
  schoolsService: baseServiceSchema,
  userFeedbackService: baseServiceSchema,
  xpService: baseServiceSchema,
  userFeedback: baseServiceSchema,
  classService: baseServiceSchema,
  subscriptionService: baseServiceSchema,
  tagService: baseServiceSchema,
  tournamentsService: baseServiceSchema,
  geolocationService: baseServiceSchema,
  trialsService: baseServiceSchema,
  parentsService: baseServiceSchema,
  schoolAnalyticsService: baseServiceSchema,
  challengeService: baseServiceSchema,
  liveFeedService: baseServiceSchema,
  shortAnswerService: baseServiceSchema,
  schoolLeaderboardsService: baseServiceSchema,
  classLeaderboardsService: baseServiceSchema,
  discordService: baseServiceSchema,
  tutoringService: baseServiceSchema,
  avatarsService: baseServiceSchema,
  tutorResourcesService: baseServiceSchema,
  notificationsService: baseServiceSchema,
  targetGradesService: baseServiceSchema,
  parentQuizService: baseServiceSchema,
  surveysService: baseServiceSchema,
  formsService: baseServiceSchema,
  featureFlagsService: baseServiceSchema,
  examQuestionStatsService: baseServiceSchema,
  studentActivityService: baseServiceSchema,
  textToSpeechService: baseServiceSchema,
  userQuizService: baseServiceSchema,
  pdfService: baseServiceSchema,
  sessionService: baseServiceSchema,
  studentReportCardsService: baseServiceSchema,
  misSyncService: baseServiceSchema
});

export const configSchema = z.object({
  services: servicesSchema
});

export type Config = z.infer<typeof configSchema>;
export type ServiceConfig = z.infer<typeof servicesSchema>;
export type ServiceKey = keyof ServiceConfig;

export type CdnServiceKey = {
  [K in keyof ServiceConfig]: ServiceConfig[K] extends { baseCdnUrl: string }
    ? K
    : never;
}[keyof ServiceConfig];
